import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsHook } from './../cjsObjects/cjsHook';

import STORE from '@/store';

export class cjsDnD extends cjsItem {
  _thrown;
  _hooks = {};

  constructor(obj) {
    super(obj);
    this.thrown = false;
  }

  _checkHook(obj) {
    if (!fJS.isNotEmptyObject(this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty))
      throw 'Brakuje gałęzi otherProperty dla grupy: ' + obj.idGroup + ' i elementu: ' + obj.idItem;

    if (!fJS.isNotEmptyObject(this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty.hooks))
      throw 'Brakuje konfiguracji HOOKS dla grupy: ' + obj.idGroup + ' i elementu: ' + obj.idItem;

    if (!Array.isArray(this._stage.groups[obj.idGroup].items[obj.idItem].otherProperty.hooks.items))
      throw 'Brakuje konfiguracji kotwic dla grupy: ' + obj.idGroup + ' i elementu: ' + obj.idItem;

    return Object.values(this._stage.groups).some((group) => {
      return Object.values(group.items).some((item) => {
        return item.otherProperty.hooks.items.some((hook) => hook.id === obj.idHook);
      });
    });
  }

  _setPropertyHook(id) {
    let i = Object.values(this.otherProperty.hooks.items).findIndex((item) => id == item.id);
    let tmp = _.cloneDeep(this.otherProperty.hooks),
      tmp1 = _.cloneDeep(this.otherProperty.hooks.items[i]);
    return _.merge(tmp, tmp1);
  }

  _setConfigsHooks(id) {
    let layout = this._setPropertyHook(id);

    this.hooks[id].setLayout('background', false, this.otherProperty.hooks, layout, false);
    this.hooks[id].setLayout('positions', false, this.otherProperty.hooks, layout, false);
    this.hooks[id].setLayout('shadow', false, this.otherProperty.hooks, layout, false);

    if (
      this.hooks[id].layout.positions &&
      fJS.isNumeric(this.hooks[id].layout.positions.columns) &&
      this.hooks[id].layout.positions.columns > 0
    ) {
      this.cols = this.hooks[id].layout.positions.columns;
      delete this.hooks[id].layout.positions.columns;
    }

    if (
      this.hooks[id].layout.positions &&
      fJS.isNumeric(this.hooks[id].layout.positions.rows) &&
      this.hooks[id].layout.positions.rows > 0
    ) {
      this.rows = this.hooks[id].layout.positions.rows;
      delete this.hooks[id].layout.positions.rows;
    }

    // PADDINGI
    this.hooks[id].setMargin('padding', false, false, layout, false);

    if (!this.hooks[id].isAbsolute()) {
      // MARGINESY
      this.hooks[id].setMargin('margin', false, false, layout, false);
    }
  }

  create() {
    Object.entries(this.hooks).map(([h, hook]) => {
      this._setConfigsHooks(h);
      hook.create();
    });

    this.arrangeItems('hooks');
    if (this.autoFit === true) {
      let mX = false,
        mY = false,
        iW = false,
        iH = false;

      Object.values(this.hooks).forEach((hook) => {
        if (mX === false || mX < hook.x) {
          mX = hook.x;
          iW = hook.width + hook.margin.right;
        }
        if (mY === false || mY < hook.y) {
          mY = hook.y;
          iH = hook.height + hook.margin.bottom;
        }
      });

      this.pos.width = fJS.isNumeric(this.pos.width) ? this.pos.width : mX + iW + this.padding.right;
      this.pos.height = fJS.isNumeric(this.pos.height) ? this.pos.height : mY + iH + this.padding.bottom;
    }

    super.create();

    Object.values(this.hooks).forEach((hook) => this._container.addChild(hook._container));
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    if (fJS.isNotEmptyObject(rules) && Array.isArray(rules.correct) && rules.correct.length > 0) {
      rules.correct
        .filter((correct) => typeof correct.idHook === 'string' && !this._checkHook(correct))
        .map((correct) => {
          throw (
            'Nie istnieje kotwica: ' +
            correct.idHook +
            ' w grupie: ' +
            correct.idGroup +
            ' w elemencie: ' +
            correct.idItem
          );
        });
    }

    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);
    this.otherProperty.hideInTarget = this.otherProperty.hideInTarget === true ? true : false;
    this.otherProperty.checkCorrectInRealTime = this.otherProperty.checkCorrectInRealTime === true ? true : false;

    if (!(fJS.isNotEmptyObject(this.otherProperty.hooks) && Array.isArray(this.otherProperty.hooks.items))) return;

    this.otherProperty.hooks.items.map((hook) => {
      this.hooks[hook.id] = new cjsHook([_.cloneDeep(hook), this._stage]);
      this.hooks[hook.id]._idx = Object.keys(this.hooks).length - 1;
      this.hooks[hook.id]._idItem = this.id;
      this.hooks[hook.id]._idGroup = this.idGroup;
    });
  }

  stageMouseDown(e, data) {
    if (STORE.getters.lockGame) {
      e.stopPropagation();
      return false;
    }
    console.log(this.id + ' cjsDnD: DOWN');

    let engine = data.engine,
      stage = data.cjsStage;

    if (engine._layout.background.image.src2) {
      let fullSrc = engine.container.children[1].image.src,
        src = engine._layout.background.image.src;
      if (fullSrc.includes(src)) {
        engine._container.children[1].x = 0;
        engine._container.children[1].y = 0;
        engine._container._cacheWidth = engine._layout.background.image.pos.width2;
        engine._container._cacheHeight = engine._layout.background.image.pos.height2;
        engine.container.children[1].image.src = engine._layout.background.image.src2;
      }
    }

    if (stage.mousedown === true || engine.block === true) {
      e.stopPropagation();
      return false;
    }
    engine._mousedown = true;
    stage.mousedown = true;
    engine.container.parent.setChildIndex(engine.container, engine.container.parent.getNumChildren() - 1);

    for (let i = 0; i < stage.stage.children.length; i++) {
      if (engine.container.parent == stage.stage.children[i]) {
        stage.stage.setChildIndex(engine.container.parent, stage.stage.getNumChildren() - 1);
        break;
      }
    }

    engine._stageXY = new createjs.Point(Math.floor(e.stageX - stage.offset.x), Math.floor(e.stageY - stage.offset.y));
    engine._mouseLocal = false;

    if (stage._stage._listeners == null || stage._stage._listeners['pressmove'] === undefined) {
      stage.listener.pm = stage._stage.on('pressmove', engine._stageMouseMove, null, false, {
        engine: engine,
        cjsStage: stage,
      });
    }

    e.stopPropagation();
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown !== true || engine._mousedown !== true) {
      e.stopPropagation();
      return false;
    }
    if (engine._mouseLocal === false) engine._mouseLocal = { x: e.localX, y: e.localY };

    engine.x += e.localX - engine._mouseLocal.x;
    engine.y += e.localY - engine._mouseLocal.y;

    engine._mouseLocal = { x: e.localX, y: e.localY };

    // console.log(engine.thrown);
    if (engine.thrown !== false) {
      let item =
        typeof engine.thrown.idHook === 'string'
          ? stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook]
          : stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem];

      if (typeof engine.thrown.idHook === 'string') {
        // console.log(stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook]);
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].isBusy = false;
      }

      if (
        typeof item.container.getChildByName('hover') != 'undefined' &&
        item.container.getChildByName('hover') !== null
      ) {
        item.container.getChildByName('hover').alpha = 0;
        // item.container.getChildByName('hover').updateCache();
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].container.updateCache();
      }
    }

    if (fJS.isNumeric(engine.aid) === false) {
      engine.thrown = engine._intersect(engine.inLine === true);
    } else {
      engine.thrown = engine._intersectRotate();
    }

    if (engine.thrown !== false) {
      let item =
        typeof engine.thrown.idHook === 'string'
          ? stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook]
          : stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem];

      if (item.layout.background.hover === true) {
        let hover = new createjs.Bitmap(engine.container.cacheCanvas);
        if (
          typeof item.container.getChildByName('hover') == 'undefined' ||
          item.container.getChildByName('hover') === null
        ) {
          hover.name = 'hover';
          item.container.addChild(hover);
        } else {
          item.container.getChildByName('hover').image = hover.image;
        }
        item.container.getChildByName('hover').alpha = 1;
      }

      // if (
      //   typeof item.container.getChildByName('hover') != 'undefined' &&
      //   item.container.getChildByName('hover') !== null
      // ) {
      //   console.log('bleble');
      //   item.container.getChildByName('hover').alpha = 1;
      //   item.container.getChildByName('hover').updateCache();
      // }

      // console.log(item.container.getChildByName('hover'));

      stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].container.updateCache();
    }
  }

  _intersectRotate(offBusy) {
    let t = [],
      width = this.width,
      height = this.height,
      p1 = this.container.localToGlobal(0, 0),
      p = this._getTransPoints({
        regX: this.container.regX,
        regY: this.container.regY,
        width: width,
        height: height,
        rotation: this.container.rotation,
      });

    for (let gr in this._stage.groups) {
      let group = this._stage.groups[gr];
      if (this._stage.config.isDev === true) group.container.alpha = 1;
      if (gr === this.idGroup) continue;

      let p2 = group.container.localToGlobal(0, 0);
      let w1 = p2.x + p.A.x,
        w2 = p2.x + group.width + p.A.x,
        h1 = p2.y + p.A.y,
        h2 = p2.y + group.height + p.A.y;
      /*
             console.log('w1: ' + w1 + ' w2: ' + w2 + ' h1: ' + h1 + ' h2: ' + h2);

             console.log('A: ' + (p1.x + p.A.x) + ' ' + (p1.y + p.A.y) );
             console.log('B: ' + (p1.x + p.B.x) + ' ' + (p1.y + p.B.y) );
             console.log('C: ' + (p1.x + p.C.x) + ' ' + (p1.y + p.C.y) );
             console.log('D: ' + (p1.x + p.D.x) + ' ' + (p1.y + p.D.y) ); */

      if (
        (p1.x + p.A.x >= w1 && p1.x + p.A.x <= w2 && p1.y + p.A.y >= h1 && p1.y + p.A.y <= h2) ||
        (p1.x + p.B.x >= w1 && p1.x + p.B.x <= w2 && p1.y + p.B.y >= h1 && p1.y + p.B.y <= h2) ||
        (p1.x + p.C.x >= w1 && p1.x + p.C.x <= w2 && p1.y + p.C.y >= h1 && p1.y + p.C.y <= h2) ||
        (p1.x + p.D.x >= w1 && p1.x + p.D.x <= w2 && p1.y + p.D.y >= h1 && p1.y + p.D.y <= h2)
      ) {
        t.push(gr);
        //    if (this._stage.config.isDev === true) group.container.alpha = 0.5;
      }
    }

    if (t.length > 0) {
      let gr = -1,
        it = -1;
      for (let i = 0; i < t.length; i++) {
        let tar = this._stage.groups[t[i]],
          d = tar.container.globalToLocal(this._stage.stage.mouseX, this._stage.stage.mouseY);
        if (tar.container.hitTest(d.x, d.y)) {
          gr = t[i];
        }
      }
      gr = typeof gr === 'string' ? gr : t[0];

      for (let i in this._stage.groups[gr].items) {
        let p2 = this._stage.groups[gr].items[i].container.localToGlobal(0, 0);
        let w1 = p2.x + p.A.x,
          w2 = p2.x + this._stage.groups[gr].items[i].width + p.A.x,
          h1 = p2.y + p.A.y,
          h2 = p2.y + this._stage.groups[gr].items[i].height + p.A.y;
        if (
          (p1.x + p.A.x >= w1 && p1.x + p.A.x <= w2 && p1.y + p.A.y >= h1 && p1.y + p.A.y <= h2) ||
          (p1.x + p.B.x >= w1 && p1.x + p.B.x <= w2 && p1.y + p.B.y >= h1 && p1.y + p.B.y <= h2) ||
          (p1.x + p.C.x >= w1 && p1.x + p.C.x <= w2 && p1.y + p.C.y >= h1 && p1.y + p.C.y <= h2) ||
          (p1.x + p.D.x >= w1 && p1.x + p.D.x <= w2 && p1.y + p.D.y >= h1 && p1.y + p.D.y <= h2)
        ) {
          it = i;
        }
      }

      if (it === -1) return false;

      let item = this._stage.groups[gr].items[it];

      if (item.hooks === undefined) {
        return { idGroup: gr, idItem: it };
      } else {
        if (this.thrown !== false && typeof this.thrown.idHook === 'string') {
          this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook].isBusy = false;
        }
        let hooks = [];

        for (let i in this._stage.groups[gr].items[it].hooks) {
          let p2 = this._stage.groups[gr].items[it].hooks[i].container.localToGlobal(0, 0);
          let w1 = p2.x + p.A.x,
            w2 = p2.x + this._stage.groups[gr].items[it].hooks[i].width + p.A.x,
            h1 = p2.y + p.A.y,
            h2 = p2.y + this._stage.groups[gr].items[it].hooks[i].height + p.A.y;
          if (
            (p1.x + p.A.x >= w1 && p1.x + p.A.x <= w2 && p1.y + p.A.y >= h1 && p1.y + p.A.y <= h2) ||
            (p1.x + p.B.x >= w1 && p1.x + p.B.x <= w2 && p1.y + p.B.y >= h1 && p1.y + p.B.y <= h2) ||
            (p1.x + p.C.x >= w1 && p1.x + p.C.x <= w2 && p1.y + p.C.y >= h1 && p1.y + p.C.y <= h2) ||
            (p1.x + p.D.x >= w1 && p1.x + p.D.x <= w2 && p1.y + p.D.y >= h1 && p1.y + p.D.y <= h2)
          ) {
            hooks.push(i);
          }
        }

        if (hooks.length > 0) {
          let h = -1;

          for (let i = 0; i < hooks.length; i++) {
            let hook = this._stage.groups[gr].items[it].hooks[hooks[i]],
              d = hook.container.globalToLocal(this._stage.stage.mouseX, this._stage.stage.mouseY);

            if (!hook.isBusy && hook.container.hitTest(d.x, d.y)) {
              h = hooks[i];
            }
          }

          h = typeof h === 'string' ? h : hooks[0];
          if (h === -1) return false;
          //   let h = hooks[0];
          if (this._stage.groups[gr].items[it].hooks[h].isBusy && offBusy !== true) return false;
          return { idGroup: gr, idItem: it, idHook: h };
        }
      }
    }

    return false;
  }

  _checkCollision(c1, c2) {
    let w = 0,
      h = 0;
    // I:
    if (c1.p.x < c2.p.x && c2.p.x < c1.p.x + c1.w && c1.p.y < c2.p.y && c2.p.y < c1.p.y + c1.h) {
      w = c2.w < c1.w - (c2.p.x - c1.p.x) ? c2.w : c1.w - (c2.p.x - c1.p.x);
      h = c2.h < c1.h - (c2.p.y - c1.p.y) ? c2.h : c1.h - (c2.p.y - c1.p.y);
      //     console.log('I');
      return w * h;
    }
    // II:
    else if (c1.p.x < c2.p.x && c2.p.x < c1.p.x + c1.w && c2.p.y < c1.p.y && c2.p.y + c2.h > c1.p.y) {
      w = c2.w < c1.w - (c2.p.x - c1.p.x) ? c2.w : c1.w - (c2.p.x - c1.p.x);
      h = c1.h < c2.h - (c1.p.y - c2.p.y) ? c1.h : c2.h - (c1.p.y - c2.p.y);
      //     console.log('II');
      return w * h;
    }
    // III:
    else if (c1.p.x > c2.p.x && c1.p.x < c2.p.x + c2.w && c1.p.y > c2.p.y && c1.p.y < c2.p.y + c2.h) {
      w = c1.w < c2.p.x + c2.w - c1.p.x ? c1.w : c2.p.x + c2.w - c1.p.x;
      h = c1.h < c2.p.y + c2.h - c1.p.y ? c1.h : c2.p.y + c2.h - c1.p.y;
      //     console.log('III');
      return w * h;
    }
    // IV:
    else if (c1.p.x > c2.p.x && c1.p.x < c2.p.x + c2.w && c1.p.y < c2.p.y && c2.p.y < c1.p.y + c1.h) {
      w = c1.w < c2.p.x + c2.w - c1.p.x ? c1.w : c2.p.x + c2.w - c1.p.x;
      h = c2.h < c1.p.y + c1.h - c2.p.y ? c2.h : c1.p.y + c1.h - c2.p.y;
      //     console.log('IV');
      return w * h;
    }
    return w * h;
  }

  _intersect(offBusy) {
    let width = this.container.width,
      height = this.container.height,
      // punkt engine na stage (+offset)
      pt = this.container.parent.localToGlobal(this.container.x, this.container.y);

    let groups = Object.values(this._stage.groups)
      .filter((group) => group.id != this.idGroup)
      .filter(
        (group) =>
          this._checkCollision(
            { p: pt, w: width, h: height },
            {
              p: {
                x: group.x + this._stage.offset.x,
                y: group.y + this._stage.offset.y,
              },
              w: group.width,
              h: group.height,
            }
          ) !== 0
      )
      .filter(
        (group) =>
          !Array.isArray(this.otherProperty?.exclusionGroups) ||
          !this.otherProperty.exclusionGroups.some(
            (ex) => ex.indexOf(this.idGroup) !== -1 && ex.indexOf(group.id) !== -1
          )
      );

    if (groups.length === 0) return false;

    let gr = groups
      .flatMap((group) => Object.values(group.items))
      .filter((item) => {
        let It = this._stage.groups[item.idGroup].container.localToGlobal(item.container.x, item.container.y),
          Iw = Math.abs(item.container.cacheMeasure.x2) - Math.abs(item.container.cacheMeasure.x1),
          Ih = Math.abs(item.container.cacheMeasure.y2) - Math.abs(item.container.cacheMeasure.y1);

        return this._checkCollision({ p: pt, w: width, h: height }, { p: It, w: Iw, h: Ih }) !== 0;
      })
      .flatMap((item) => {
        if (Object.keys(item.hooks).length == 0) {
          let It = this._stage.groups[item.idGroup].container.localToGlobal(item.container.x, item.container.y),
            Iw = Math.abs(item.container.cacheMeasure.x2) - Math.abs(item.container.cacheMeasure.x1),
            Ih = Math.abs(item.container.cacheMeasure.y2) - Math.abs(item.container.cacheMeasure.y1);
          return { item: item, p: this._checkCollision({ p: pt, w: width, h: height }, { p: It, w: Iw, h: Ih }) };
        }
        return Object.values(item.hooks);
      })
      .filter((hook) => {
        if (!(hook instanceof cjsHook)) return true;
        return !(hook.isBusy === true && offBusy !== true);
      })
      .filter((hook) => {
        if (!(hook instanceof cjsHook)) return true;
        let ht = this._stage.groups[hook.idGroup].items[hook.idItem].container.localToGlobal(
            hook.container.x,
            hook.container.y
          ),
          hw = hook.width,
          hh = hook.height;

        return this._checkCollision({ p: pt, w: width, h: height }, { p: ht, w: hw, h: hh }) !== 0;
      })
      .flatMap((hook) => {
        if (!(hook instanceof cjsHook)) return hook;
        let ht = this._stage.groups[hook.idGroup].items[hook.idItem].container.localToGlobal(
            hook.container.x,
            hook.container.y
          ),
          hw = hook.width,
          hh = hook.height;
        return { item: hook, p: this._checkCollision({ p: pt, w: width, h: height }, { p: ht, w: hw, h: hh }) };
      });

    if (gr.length > 0) {
      if (this.thrown !== false && typeof this.thrown.idHook === 'string') {
        this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook].isBusy = false;
      }

      let max = _.maxBy(gr, 'p');

      if (max.item instanceof cjsHook)
        return {
          idGroup: max.item.idGroup,
          idItem: max.item.idItem,
          idHook: max.item.id,
        };
      return {
        idGroup: max.item.idGroup,
        idItem: max.item.id,
      };
    }
    return false;
  }

  _getTransPoints(e) {
    let obj = {},
      angle = e.rotation * (Math.PI / 180); //  => RADIAN

    let G = [
      [Math.cos(angle), Math.sin(angle), 0],
      [-Math.sin(angle), Math.cos(angle), 0],
      [
        e.regX * (1 - Math.cos(angle)) + e.regY * Math.sin(angle),
        -e.regX * Math.sin(angle) + e.regY * (1 - Math.cos(angle)),
        1,
      ],
    ];

    obj.A = this._getTPoint({ x: 0, y: 0 }, G);
    obj.B = this._getTPoint({ x: 0 + e.width, y: 0 }, G);
    obj.C = this._getTPoint({ x: 0 + e.width, y: 0 + e.height }, G);
    obj.D = this._getTPoint({ x: 0, y: 0 + e.height }, G);

    return obj;
  }

  _getTPoint(e, G) {
    let A = [],
      P = [
        [1, 0, 0],
        [0, 1, 0],
        [e.x, e.y, 1],
      ];
    for (let i = 0; i < P.length; i++) {
      A[i] = [];
      for (let j = 0; j < P.length; j++) {
        A[i][j] = 0;
        for (let k = 0; k < P.length; k++) {
          A[i][j] += P[i][k] * G[k][j];
        }
      }
    }

    return new createjs.Point(A[2][0], A[2][1]);
  }

  stageMouseUp(e, data) {
    console.log(this.id + ' cjsDnD: UP');

    let engine = data.engine;
    let stage = data.cjsStage;
    if (stage.mousedown !== true) {
      e.stopPropagation();
      return;
    }

    // console.log(engine.thrown);

    if (
      engine.thrown === false ||
      (engine.thrown !== false && engine.thrownInTarget() === false) ||
      (engine.thrown.idHook !== undefined &&
        (stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].block === true ||
          stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].isBusy === true))
    ) {
      engine.dropItem();
      if (engine._layout.background.image.src2) {
        engine._container.children[1].image.src = engine._layout.background.image.src;
        engine._container.children[1].x = engine._layout.background.image.pos.x;
        engine._container.children[1].y = engine._layout.background.image.pos.y;
        engine._container._cacheWidth = engine._layout.positions.pos.width;
        engine._container._cacheHeight = engine._layout.positions.pos.height;
      }
    } else if (engine.thrown.idHook !== undefined) {
      if (engine._layout.background.image.src2) {
        for (let it_ in stage.groups[engine.idGroup].items) {
          stage.groups[engine.idGroup].items[it_].block = true;
        }
      }
      let pt = engine.container.localToLocal(
        engine.regX,
        engine.regY,
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].container
      );

      engine.pos.x =
        engine.x -
        pt.x +
        engine.regX +
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].padding.left;
      engine.pos.y =
        engine.y -
        pt.y +
        engine.regY +
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].padding.top;
      if (stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hooks.autoResize === true) {
        engine.pos.scaleX =
          stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].width /
          engine.width;
        engine.pos.scaleY =
          stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].height /
          engine.height;
      } else if (
        typeof stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hooks.autoResize ==
          'object' &&
        stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hooks.autoResize != null
      ) {
        if (
          Math.sign(
            stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hooks.autoResize.width
          ) >= 0
        ) {
          engine.pos.scaleX =
            stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hooks.autoResize.width /
            engine.width;
        }
        if (
          Math.sign(
            stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hooks.autoResize.height
          ) >= 0
        ) {
          engine.pos.scaleY =
            stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hooks.autoResize.height /
            engine.height;
        }
      }
      stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].hooks[engine.thrown.idHook].isBusy = true;
      stage.movesTo.push(engine);
    }
    if (engine.thrown !== false) {
      if (engine.otherProperty.hideInTarget === true) {
        engine.container.visible = false;
      }
      if (stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem].otherProperty.hideInTarget === true) {
        engine.container.visible = false;
      }
    }

    if (engine.thrown !== false) {
      stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');
    }

    if (engine.otherProperty.checkCorrectInRealTime === true) {
      // console.log('checkCorrectInRealTime');
      let isCorrect = engine.checkInRealTime();
      if (isCorrect === true) {
        stage.sounds.play(engine.idGroup + '.' + engine.id + '.correct');
      } else if (isCorrect === false) {
        stage.sounds.play(engine.idGroup + '.' + engine.id + '.wrong');
        engine.dropItem(true);
      }
    }

    engine.stopMove(e);
    if (stage.autoCheckAllCorrect === true && cjsDnD.checkGameAction.call(this, stage, false) === true) {
      console.log('autoCheckAllCorrect');
      STORE.dispatch('checkGame');
    }
  }

  thrownInTarget() {
    let targets = {};

    // wyłapanie target'ów
    for (let gr in this._stage.groups) {
      for (let i in this._stage.groups[gr].items) {
        let item = this._stage.groups[gr].items[i];
        item.isCorrect = false;

        if (item.block === false || item.thrown !== false) continue;
        if (typeof targets[gr] !== 'object' || targets[gr] === null) targets[gr] = {};
        targets[gr][i] = {
          items: [],
          correct: _.cloneDeep(item.correct),
          pickCorrect:
            typeof item.otherProperty === 'object' && fJS.isNumeric(item.otherProperty.pickCorrect)
              ? item.otherProperty.pickCorrect
              : false,
        };
      }
    }

    return typeof targets[this.thrown.idGroup] == 'object' && targets[this.thrown.idGroup] !== null;
  }

  checkInRealTime() {
    if (this.thrown === false) return false;
    if (this.correct.length === 0) {
      this.dropItem(true);
      return false;
    }

    let isCorrect = false;
    for (let i in this.correct) {
      if (
        this.correct[i].idGroup === this.thrown.idGroup &&
        this.correct[i].idItem === this.thrown.idItem &&
        this.correct[i].idHook === this.thrown.idHook
      )
        isCorrect = true;
    }

    return isCorrect;
  }

  dropItem(droped) {
    if (this.thrown !== false) this.block = false;
    if (this._stage.removeInCorrects === true || droped === true || this._stage.backToSource === true) {
      if (this.thrown === false && this.pos.x === this.x && this.pos.y === this.y) return false;
      // console.log('DROP: ' + this.idGroup + ' - ' + this.id);
      if (this.thrown != false) {
        if (
          this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].otherProperty.hideInTarget === true ||
          this.otherProperty.hideInTarget === true
        ) {
          this.container.visible = true;
        }
        for (let i in this.thrown) {
          if (i === 'idHook') {
            let hook = this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook];
            if (
              typeof hook.container.getChildByName('hover') != 'undefined' &&
              hook.container.getChildByName('hover') !== null
            ) {
              hook.container.getChildByName('hover').alpha = 0;
              this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].container.updateCache();
            }
            hook.isBusy = false;
          }
        }
        for (let i in this.thrown) {
          delete this.thrown[i];
        }
        this.thrown = false;
      }
      this.pos = _.cloneDeep(this.posStart);
      if (this.pos.scaleX != this.sizeStart.scaleX || this.pos.scaleY != this.sizeStart.scaleY) {
        this.pos.scaleX = this.sizeStart.scaleX;
        this.pos.scaleY = this.sizeStart.scaleY;
      }

      this._stage.movesTo.push(this);
    }
    return false;
  }

  stopMove(e) {
    this._stage.mousedown = false;
    this._mousedown = false;
    this._stage.stage.off('pressmove', this._stage.listener.pm);

    e.stopPropagation();
  }

  get inLine() {
    return typeof this.otherProperty.inLine === 'boolean'
      ? this.otherProperty.inLine
      : this._stage.defConfig.sorting.inLine;
  }

  get thrown() {
    return this._thrown;
  }
  set thrown(v) {
    this._thrown = v;
  }
  get hooks() {
    return this._hooks;
  }
  set hooks(v) {
    this._hooks = v;
  }
}

cjsDnD.checkGameAction = function (stage, droped) {
  console.log('cjsDnD CHECK');

  let isCorrect = true,
    targets = {};

  // wyłapanie target'ów
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      item.isCorrect = false;

      if (item.block === false || item.thrown !== false) continue;
      if (typeof targets[gr] !== 'object' || targets[gr] === null) targets[gr] = {};
      targets[gr][i] = {
        items: [],
        correct: _.cloneDeep(item.correct),
        maxCorrect: 0,
        isCorrects: 0,
        left: 0,
        pickCorrect:
          typeof item.otherProperty === 'object' && fJS.isNumeric(item.otherProperty.pickCorrect)
            ? item.otherProperty.pickCorrect
            : false,
      };
    }
  }

  // SPRAWDZENIE SOURCE
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];

      if (item.block === true && item.thrown === false) continue;

      if (item.thrown === false && item.correct.length === 0) {
        item.isCorrect = true;
        continue;
      }

      if (item.thrown === false) {
        continue;
      }
      let idx = -1;
      let isHook = true;

      for (let k = 0; k < targets[item.thrown.idGroup][item.thrown.idItem].correct.length; k++) {
        if (
          targets[item.thrown.idGroup][item.thrown.idItem].correct[k].idGroup == item.idGroup &&
          targets[item.thrown.idGroup][item.thrown.idItem].correct[k].idItem == item.id &&
          (typeof targets[item.thrown.idGroup][item.thrown.idItem].correct[k].idHook == undefined ||
            targets[item.thrown.idGroup][item.thrown.idItem].correct[k].idHook == null)
        ) {
          isHook = false;
        }
      }

      for (let j = 0; j < targets[item.thrown.idGroup][item.thrown.idItem].items.length; j++) {
        let check = targets[item.thrown.idGroup][item.thrown.idItem].items[j];
        if (check.idItem !== item.id || check.idGroup !== item.idGroup) continue;
        idx = j;
      }

      if (idx === -1) {
        targets[item.thrown.idGroup][item.thrown.idItem].items.push({
          idItem: item.id,
          idGroup: item.idGroup,
          count: 1,
          idSources: new Array(item.id + (item.isClone === true ? '_' + item.clone.nrCopy : '')),
        });
      } else {
        targets[item.thrown.idGroup][item.thrown.idItem].items[idx].count++;
        targets[item.thrown.idGroup][item.thrown.idItem].items[idx].idSources.push(
          item.id + (item.isClone === true ? '_' + item.clone.nrCopy : '')
        );
      }
    }
  }

  for (let gr in targets) {
    for (let i in targets[gr]) {
      for (let j = 0; j < targets[gr][i].items.length; j++) {
        let item = stage.groups[targets[gr][i].items[j].idGroup].items[targets[gr][i].items[j].idItem];

        for (let c1 = 0; c1 < targets[gr][i].correct.length; c1++) {
          if (targets[gr][i].correct[c1].idGroup !== item.idGroup || targets[gr][i].correct[c1].idItem !== item.id) {
            continue;
          }
          if (fJS.isNumeric(targets[gr][i].correct[c1].count) !== true) {
            targets[gr][i].maxCorrect++;
            targets[gr][i].correct[c1].count = 1;
          } else {
            targets[gr][i].maxCorrect += targets[gr][i].correct[c1].count;
          }
        }
      }
      targets[gr][i].left =
        targets[gr][i].correct.length === 0
          ? 0
          : fJS.isNumeric(targets[gr][i].pickCorrect)
          ? targets[gr][i].pickCorrect
          : targets[gr][i].maxCorrect > targets[gr][i].correct.length
          ? targets[gr][i].maxCorrect
          : targets[gr][i].correct.length;
    }
  }

  // SPRAWDZANIE
  let removeFromTarget = [];
  for (let gr in targets) {
    for (let i in targets[gr]) {
      // gdy target powinien pozostać pusty
      if (targets[gr][i].items.length === 0 && targets[gr][i].correct.length === 0) {
        stage.groups[gr].items[i].isCorrect = true;
        continue;
      }

      for (let j = 0; j < targets[gr][i].items.length; j++) {
        for (let k = 0; k < targets[gr][i].items[j].idSources.length; k++) {
          let item = stage.groups[targets[gr][i].items[j].idGroup].items[targets[gr][i].items[j].idSources[k]];

          if (item.correct.length === 0 && item.thrown !== false) {
            if (droped !== false) {
              if (
                stage.removeAllFromBadTarget === true &&
                removeFromTarget.findIndex(
                  (x) => x.idGroup === item.thrown.idGroup && x.idItem === item.thrown.idItem
                ) === -1
              ) {
                removeFromTarget.push({ idGroup: item.thrown.idGroup, idItem: item.thrown.idItem });
              }
              if (stage.removeInCorrects === true) {
                if (item._layout.background.image.src2) {
                  item._container.children[1].x = item._layout.background.image.pos.x;
                  item._container.children[1].y = item._layout.background.image.pos.y;
                  item._container._cacheWidth = item._layout.positions.pos.width;
                  item._container._cacheHeight = item._layout.positions.pos.height;
                  item._container.children[1].image.src = item._layout.background.image.src;
                  for (let it_ in stage.groups[item.idGroup].items) {
                    stage.groups[item.idGroup].items[it_].block = false;
                  }
                }
                item.dropItem();
              }
            }

            continue;
          }

          for (let c = 0; c < item.correct.length; c++) {
            if (
              fJS.isEqual(item.correct[c], item.thrown, true) === false &&
              fJS.isEqual(fJS.removeProps('count')(item.correct[c]), item.thrown, true) === false
            ) {
              continue;
            }
            for (let c1 = 0; c1 < targets[gr][i].correct.length; c1++) {
              if (
                fJS.isEqual(
                  fJS.removeProps('count', 'idItem', 'idGroup')(targets[gr][i].correct[c1]),
                  fJS.removeProps('idItem', 'idGroup')(item.thrown),
                  true
                ) === false
              )
                continue;

              if (targets[gr][i].pickCorrect === false) {
                if (
                  targets[gr][i].correct[c1].idGroup === item.idGroup &&
                  targets[gr][i].correct[c1].idItem === item.id
                ) {
                  if (targets[gr][i].correct[c1].count > 0) {
                    item.isCorrect = true;
                    targets[gr][i].correct[c1].count--;
                    targets[gr][i].left--;
                  }
                }
                targets[gr][i].isCorrects = targets[gr][i].maxCorrect - targets[gr][i].left;
              } else {
                if (
                  targets[gr][i].correct[c1].idGroup === item.idGroup &&
                  targets[gr][i].correct[c1].idItem === item.id &&
                  targets[gr][i].isCorrects < targets[gr][i].pickCorrect &&
                  targets[gr][i].correct[c1].count > 0
                ) {
                  if (
                    (stage.removeAllForBadCount === true &&
                      targets[gr][i].pickCorrect === targets[gr][i].items.length) ||
                    stage.removeAllForBadCount === false
                  ) {
                    item.isCorrect = true;
                    targets[gr][i].correct[c1].count--;
                    targets[gr][i].left--;
                  }
                }

                targets[gr][i].isCorrects = targets[gr][i].pickCorrect - targets[gr][i].left;
              }
            }
            if (
              targets[gr][i].left === 0 &&
              ((targets[gr][i].pickCorrect !== false && targets[gr][i].isCorrects === targets[gr][i].pickCorrect) ||
                targets[gr][i].isCorrects === targets[gr][i].maxCorrect)
            )
              stage.groups[gr].items[i].isCorrect = true;
          }
          if (item.isCorrect === true && stage.correctBlock === true && droped !== false) {
            item.block = true;
            continue;
          }
          if (item.isCorrect === false && droped !== false) {
            if (
              stage.removeAllFromBadTarget === true &&
              removeFromTarget.findIndex(
                (x) => x.idGroup === item.thrown.idGroup && x.idItem === item.thrown.idItem
              ) === -1
            ) {
              removeFromTarget.push({ idGroup: item.thrown.idGroup, idItem: item.thrown.idItem });
            }
            if (stage.removeInCorrects === true) {
              item.dropItem();
            }
          }
        }
      }
    }
  }
  // console.log(targets);
  // console.log(removeFromTarget);
  if (removeFromTarget.length > 0) {
    for (let i in removeFromTarget) {
      for (let gr1 in stage.groups) {
        if (gr1 == removeFromTarget[i].idGroup) {
          continue;
        }
        for (let i1 in stage.groups[gr1].items) {
          let item = stage.groups[gr1].items[i1];
          if (item.block === true) {
            continue;
          }
          if (
            item.thrown !== false &&
            item.thrown.idGroup == removeFromTarget[i].idGroup &&
            item.thrown.idItem == removeFromTarget[i].idItem
          ) {
            item.dropItem();
          }
        }
      }
    }
  }

  for (let gr in targets) {
    for (let i in targets[gr]) {
      isCorrect = stage.groups[gr].items[i].isCorrect === false ? false : targets[gr][i].left !== 0 ? false : isCorrect;

      // console.log(
      //   gr +
      //     ' - ' +
      //     i +
      //     ': isCorrect: ' +
      //     stage.groups[gr].items[i].isCorrect +
      //     ' left: ' +
      //     targets[gr][i].left +
      //     ' isCorrects: ' +
      //     targets[gr][i].isCorrects +
      //     ''
      // );
    }
  }

  // console.log('isCorrect: ' + isCorrect);
  // console.log(targets);

  return isCorrect;
};
